import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RmBudgetRequest } from './rm-budget-req';
export class RmBudgetResponseModel extends GlobalResponseObject{
    data?: RmBudgetRequest[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: RmBudgetRequest[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
